import React from 'react'
import { withContext } from 'ddiForm'
import { getIn, is } from 'utils'
import { useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { debounce, noop } from 'lodash'
import { removeModal } from 'modals/actions'
import { handleShipperHQInteraction } from '../../../actions'

const marginRight = { marginRight: 5 }

const ActionButtons = ({
  form,
  modalId,
  onClickSaveButton = noop,
  onClickSelectLowestRate = noop,
  isEditing,
  total
}) => {
  const dispatch = useDispatch()

  const cancelFreightQuote = debounce(e => {
    dispatch(
      handleShipperHQInteraction.try(form, {
        apiParams: {
          action: 'cancel'
        },
        modalId
      })
    )
  }, 300)

  return (
    <div
      className="sales-order-entry-modal-action-buttons"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 0 0 0'
      }}
    >
      <p
        style={{
          alignItems: 'center',
          display: 'flex',
          fontSize: '1em',
          margin: 0
        }}
      >
        <span style={{ marginRight: 3 }}>Total:</span>
        <span>{total}</span>
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: '10px 0 0 0'
        }}
      >
        <Button
          onClick={onClickSelectLowestRate}
          variant="contained"
          style={marginRight}
          tabIndex={-1}
        >
          Select Lowest Rate
        </Button>
        <Button
          onClick={onClickSaveButton}
          variant="contained"
          style={marginRight}
          tabIndex={-1}
        >
          Save
        </Button>
        <Button onClick={cancelFreightQuote} variant="contained" tabIndex={-1}>
          Exit
        </Button>
      </div>
    </div>
  )
}

export default ActionButtons
